import {
  CREATE_APOLICE_SUCCESS,
  CREATE_APOLICE_FAIL,
  UPDATE_APOLICE_SUCCESS,
  UPDATE_APOLICE_FAIL,
  DELETE_APOLICE_SUCCESS,
  DELETE_APOLICE_FAIL
} from "./actionTypes";

const INIT_STATE = {
  apolices: [],
  error: {},
};

const apolicesReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_APOLICE_SUCCESS:
      return {
        ...state,
        apolices: [...state.apolices, action.payload],
      };

    case CREATE_APOLICE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_APOLICE_SUCCESS:
      return {
        ...state,
        apolices: state.apolices.map(apolice =>
          apolice.id.toString() === action.payload.id.toString()
            ? { ...apolice, ...action.payload }
            : apolice
        ),
      };

    case UPDATE_APOLICE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_APOLICE_SUCCESS:
      return {
        ...state,
        apolices: state.apolices.filter(apolice =>
          apolice.id.toString() !== action.payload.toString()
        ),
      };

    case DELETE_APOLICE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default apolicesReducer;
